<svg class="≈animate-spin ≈duration-1000 ≈ease-linear ≈z-10 ≈aspect-square" viewBox="0 0 50 50"
    [ngClass]="{
            '≈w-4 md:≈w-5 lg:≈w-6': styling.sizeIs('small'),
            '≈w-5 md:≈w-6 lg:≈w-7': styling.sizeIs('medium') || !styling.props.size,
            '≈w-6 md:≈w-7 lg:≈w-8': styling.sizeIs('large')
        }">

    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"
        [ngClass]="{
            '≈stroke-interactive-default': styling.modeIs(UITextMode.default),
            '≈stroke-warning-borders-default': styling.modeIs(UITextMode.warning),
            '≈stroke-critical-borders-default': styling.modeIs(UITextMode.critical),
            '≈stroke-success-borders-default': styling.modeIs(UITextMode.success),
            '≈stroke-highlight-borders-default': styling.modeIs(UITextMode.highlight),
            '≈stroke-primary-actions-default': styling.modeIs(UITextMode.primary),
            '≈stroke-disabled-border': styling.modeIs(UITextMode.disabled)
        }">

    </circle>

</svg>

<style>
    :host {
        width: fit-content !important;
        height: fit-content !important;
    }

    .path {
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {   
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
</style>
